var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "video-camera-a",
    width: 13,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "video-camera-c",
    d: "M2,2 L2,12 L15,12 L15,2 L2,2 Z M17,4.0954626 L20.5133571,2.12178132 C21.1834064,1.76317778 22,2.23954815 22,2.98903356 L22,11.0109664 C22,11.7604518 21.1834064,12.2368222 20.5133571,11.8782187 L17,9.91175081 L17,12 C17,13.1045695 16.1045695,14 15,14 L2,14 C0.8954305,14 0,13.1045695 0,12 L0,2 C0,0.8954305 0.8954305,0 2,0 L15,0 C16.1045695,0 17,0.8954305 17,2 L17,4.0954626 Z M19.9558105,9.43862799 L19.9558105,4.68369936 L16,7.06116368 L19.9558105,9.43862799 Z M13,5.5 C12.1715729,5.5 11.5,4.82842712 11.5,4 C11.5,3.17157288 12.1715729,2.5 13,2.5 C13.8284271,2.5 14.5,3.17157288 14.5,4 C14.5,4.82842712 13.8284271,5.5 13,5.5 Z M2,10 L2,8 L15,8 L15,10 L2,10 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "video-camera-b",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#video-camera-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#video-camera-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFA0A0",
    mask: "url(#video-camera-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-3 -15)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "video-camera-d",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#video-camera-c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#video-camera-c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7600FF",
    mask: "url(#video-camera-d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-1 -5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.5997bd8a55509133872b058f611952d3.svg";
export { ForwardRef as ReactComponent };